export const HOME = "/";
export const ABOUT = "/about-us";
export const BLOG = "/blog";
export const SEARCH = "/result";
export const LOGIN = "/login"
export const VERIFY_OTP = "/verify-otp";
export const SIGN_UP = "sign-up";
export const ONBOARDING = "onboarding";
export const SUCCESS = "/success";
export const DASHBOARD = "/dashboard";
export const LISTINGS = "listings";
export const CATALOG = "catalog";
export const INSPECTION = "inspections";
export const PAYMENTS = "payments";
export const SETTINGS = "settings";
export const ADMIN_USER_MGT = "user-mgt";
export const ADMIN_BOOKING = "booking-mgt"
export const ADMIN_PROP_MGT = "prop-mgt";
export const ADMIN_ANALYTICS = "analytics";
export const ADMIN_CONTENT_MGT = "content-mgt"
export const ADMIN_PAYMENTS = "payments-mgt";

export const SYSTEM = "system";
export const GENERAL = "general";
